import { render, staticRenderFns } from "./ShopProducts.vue?vue&type=template&id=533ac3fb&scoped=true&"
import script from "./ShopProducts.vue?vue&type=script&lang=js&"
export * from "./ShopProducts.vue?vue&type=script&lang=js&"
import style0 from "./ShopProducts.vue?vue&type=style&index=0&id=533ac3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ac3fb",
  null
  
)

export default component.exports